import { SurveyPDF } from "survey-pdf";
import dayjs from "dayjs";

const removeVisibilityConditions = (element) => {
  if (element.type === "panel" && element.elements) {
    return {
      ...element,
      elements: element.elements.map(removeVisibilityConditions),
    };
  } else if (element.type === "matrix" && element.columns) {
    return {
      ...element,
      columns: element.columns.map((column) => ({ ...column, visibleIf: undefined })),
      rows: element.rows.map((row) => ({ ...row, visibleIf: undefined })),
      visibleIf: undefined,
    };
  } else if (element.type === "matrixdynamic" || element.type === "matrixdropdown") {
    return {
      ...element,
      columns: element.columns.map((column) => ({ ...column, visibleIf: undefined })),
      visibleIf: undefined,
    };
  } else {
    return { ...element, visibleIf: undefined };
  }
};

const makeFormatElements = (includeIds) => {
  const getTitleWithId = (element) => {
    if (typeof element === "object" && element !== null) {
      const title = element.title || element.text || "";
      const name = element.name || element.value || "";
      if (title && name) return includeIds ? `${title} [${name}]` : title;
      if (title) return title;
      if (name) return includeIds ? `[${name}]` : name;
    }
    return element !== undefined && element !== null ? String(element) : "No value available";
  };

  const formatElements = (element) => {
    if (element.type === "panel" && element.elements) {
      return { ...element, elements: element.elements.map(formatElements) };
    } else if (element.type === "matrix" && element.columns) {
      return {
        ...element,
        columns: element.columns.map((col) => ({ ...col, title: getTitleWithId(col) })),
        rows: element.rows.map((row) => ({ ...row, text: getTitleWithId(row) })),
      };
    } else if (element.type === "matrixdynamic" || element.type === "matrixdropdown") {
      return {
        ...element,
        columns: element.columns.map((col) => ({
          ...col,
          title: getTitleWithId(col),
          value: col.value ?? "",
        })),
        rows: element.rows
          ? element.rows.map((row) => ({
              ...row,
              text: getTitleWithId({ title: row.text, name: row.value }),
              value: row.value ?? "",
            }))
          : [],
      };
    } else {
      return { ...element, title: getTitleWithId(element), value: element.value ?? "" };
    }
  };

  return formatElements;
};

export const buildSurveyPages = (surveyData, includeAnswers, includeIds = false) => {
  const formatElements = makeFormatElements(includeIds);
  const pages = [];
  let answers = {};

  surveyData?.forEach((survey) => {
    survey.surveyJson?.pages?.forEach((page) => {
      const modifiedPage = {
        ...page,
        elements: page.elements?.map(removeVisibilityConditions).map(formatElements),
      };
      pages.push({ ...modifiedPage, title: survey.surveyJson?.title });
    });
    if (includeAnswers) {
      answers = { ...answers, ...survey.answer_json_obj };
    }
  });

  return { pages, answers };
};

export const buildEcrfPdfFilename = (trialName, siteId, participantId, visitName, timestamp) => {
  const visitInfo = visitName?.replace(/\s+/g, "_") || "Visit";
  return `${timestamp}_${trialName}_${siteId}-${participantId}_${visitInfo}`;
};

export const generateEcrfPdfBlob = async (
  surveyData,
  { trialName, visitName, siteId, participantId, timestamp }
) => {
  const { pages, answers } = buildSurveyPages(surveyData, true, false);

  const surveyPdf = new SurveyPDF({ pages });
  surveyPdf.data = answers;

  const date = dayjs().format("Do MMMM YYYY");

  const visitLabel = visitName?.replace(/_/g, " ") || "Visit";
  surveyPdf.onRenderFooter.add((_, canvas) => {
    canvas.drawText({
      text: `Trial: ${trialName}    Visit: ${visitLabel}    SiteID-SubjectsID: ${siteId}-${participantId}    Date: ${date}`,
      fontSize: 10,
      isBold: true,
    });
  });

  return surveyPdf.raw("blob");
};
